import { section } from "framer-motion/client";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { Banner, TermsImage } from "../images";
import { useState, useEffect } from "react";
import useSlug from "./SlugComp";
import SEO from "./Seo";
import { getPagesBySlug } from "../services/apiService";

const termsofService = [
  {
    title: "Introduction",
    section:
      "Welcome to TechProjects (“we,” “our,” “us”). By accessing or using our website, services, or products (“Services”), you agree to be bound by these Terms of Service (“Terms”). If you do not agree, please do not use our Services.",
  },
  {
    title: "Use of Services",
    section:
      "You agree to use our Services only for lawful purposes and in compliance with all applicable laws. You shall not:",
    bullets: [
      "Copy, modify, or distribute our content without permission.",
      "Attempt to gain unauthorized access to our systems or data.",
      "Use our Services for any malicious, fraudulent, or harmful activity.",
    ],
  },
  {
    title: "Intellectual Property",
    section:
      "All content, trademarks, logos, designs, and software on our website are the property of TechProjects or its partners. Unauthorized use may result in legal action.",
  },
  {
    title: "hird-Party Services",
    section:
      "Our Services may integrate with or link to third-party platforms. We are not responsible for the content, privacy policies, or practices of any third-party services.",
  },
  {
    title: "Disclaimers",
    section:
      "Our Services are provided “as is” without warranties of any kind, whether express or implied. We do not guarantee uninterrupted or error-free operation.",
  },
  {
    title: "Limitation of Liability",
    section:
      "To the maximum extent permitted by law, TechProjects is not liable for any indirect, incidental, special, or consequential damages arising from your use or inability to use our Services.",
  },
  {
    title: "Termination",
    section:
      "We may suspend or terminate access to our Services at any time, without notice, for conduct that violates these Terms or is harmful to our business.",
  },
  {
    title: "Governing Law",
    section:
      "These Terms shall be governed by and construed under the laws of the jurisdiction in which TechProjects operates (United States), without regard to its conflict of laws principles.",
  },
  {
    title: "Changes to Terms",
    section:
      "We may update these Terms from time to time. Continued use of our Services constitutes acceptance of any revised Terms.",
  },
  {
    title: "Contact Us",
    section: "If you have questions about these Terms, please contact us",
  },
];

function TermsOfService() {
  const [metaData, setMetaData] = useState({});
  const slug = useSlug();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const slugData = await getPagesBySlug(slug.toLowerCase());
        setMetaData(slugData.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    fetchJobs();
  }, []);
  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[460px]">
          <img
            src={Banner}
            alt="Banner"
            className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-[56rem] font-roboto space-y-6 mt-16">
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Terms of Service
              </h1>
              <p className="text-md text-[#404040]">
                Effective Date: October 24, 2025
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-16">
              <img src={TermsImage} alt="image" className="w-full h-auto" />
            </div>
          </div>
        </div>
        <section className="py-20 bg-white px-6 md:px-10 font-roboto">
          <div className="max-w-3xl mx-auto py-8 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <ul className="flex flex-col gap-4">
              {termsofService?.map((item, idx) => (
                <li className="text-[#0F172A] font-bold text-2xl list-decimal">
                  {item?.title} <br />
                  <p className="font-400 text-lg text-[#323232] mt-4">
                    {item?.section}
                  </p>
                  {termsofService[idx]?.bullets?.length > 0 && (
                    <ul className="space-y-2 font-400 text-lg ml-8 mt-4 text-[#0F172A]">
                      {termsofService[idx].bullets.map((b, i) => (
                        <li key={i} className="list-disc">
                          {b}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default TermsOfService;
